/**
 **@author       yontaek@zumper.com (Yon Taek Chung)
 **@copyright    Copyright (c) 2024, Zumper
 */

import { Flex, Image, Link, Text } from '@chakra-ui/react'
import { POPULAR_CITIES_CLICK, event } from '@zcode-ui/web-zumper-integrations'
import { EVENT_NAMES, HOMEPAGE, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { APTS_BASE_URL } from '@zcode/nr-utils'
import { rootRelative } from '@zcode/utils'
import React from 'react'
import { useDispatch } from 'react-redux'

export const CityCard = ({ image, text, url }: { image?: string; text?: string; url: string }) => {
  const dispatch = useDispatch()
  const onClick = () => {
    dispatch(
      event({
        name: POPULAR_CITIES_CLICK,
        props: { pageType: PAGE_NAMES.HOMEPAGE, cityState: url },
      })
    )
    track({
      event: EVENT_NAMES.CLICK,
      payload: {
        [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.HOMEPAGE,
        [PROP_NAMES.SECTION]: HOMEPAGE.POPULAR_CITIES,
        [PROP_NAMES.BUTTON_CLICKED]: url,
      },
    })
  }
  return (
    <Link
      as="a"
      href={rootRelative(`/${APTS_BASE_URL}/${url}`)}
      key={url}
      onClick={onClick}
      textDecoration="none"
      w={{
        base: 'calc((100% - 64px) / 2)',
        desktop: 'calc((100% - 72px) / 4)',
        lg: 'calc((100% - 64px) / 5)',
        xl: 'calc((100% - 96px) / 5)',
      }}
    >
      <Flex flexDir="column" gap={{ base: 2, desktop: 4 }}>
        <Image alt="" objectFit="cover" src={image} flexShrink={0} loading="lazy" />
        <Text
          fontSize={{ base: 'md', desktop: 'lg' }}
          fontWeight="bold"
          lineHeight={6}
          color="gray.950"
          w={{ base: '156px', desktop: '142px', lg: '153px', xl: '220px' }}
        >
          {text}
        </Text>
      </Flex>
    </Link>
  )
}
